<template>
  <div class="btn-list aside">
    <div class="rule-btn" @click="handleRuleClick"></div>
    <div class="website-btn" @click="handleWebsiteClick"></div>
    <div class="fb-btn" @click="handleFacebookClick"></div>
    <div class="dc-btn" @click="handleDiscordClick"></div>
  </div>
  <div class="rule-btn-mobile" @click="handleRuleClick"></div>
</template>

<script setup>
// Props & Emits
const emit = defineEmits([
  "showRulePopup",
  "jumpToWebsite",
  "jumpToFacebook",
  "jumpToDiscord",
]);

// 方法
const handleRuleClick = () => {
  emit("showRulePopup");
};

const handleWebsiteClick = () => {
  // 默认跳转地址
  emit("jumpToWebsite");
};

const handleFacebookClick = () => {
  emit("jumpToFacebook");
};

const handleDiscordClick = () => {
  emit("jumpToDiscord");
};
</script>
